import classes from './WidgetEmail.module.css';

const WidgetEmail = ({ value, onChange }) => {
    return <input type="email" className={classes.input} value={value} onChange={(e) => { onChange(e.target.value) }} />
}

export default WidgetEmail;